import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Dropdown, Menu, Drawer, Button, Space, notification } from "antd";
import Pagination from "@mui/material/Pagination";
import ShowData from "../../../components/ShowData";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
  faEllipsis,
  faCloudDownload,
  faEye,
  faExclamationCircle,
  faCheckCircle,
  faTimes,
  faRefresh,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";

import TobNavBar from "../../DashBaord/Top_navbar";

import { Link, useNavigate } from "react-router-dom";

import moment from "moment";
import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  Orderlist,
  cancelOrder,
  changeDeliveryStatus
} from "../../../controllers/V1/products/productController";
import { getPage } from "../../../controllers/common";
import ExportPopup from "./orderListExport";
import { ASSETS_BASE_URL } from "../../../config/constants";

import { formatProjectDate } from "../../../controllers/common";
import { usePermissions } from "../../../controllers/PermissionContext";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { list as generalData } from "../../../controllers/V1/cms/generalDataController";
import { statusMessage } from "../../../controllers/common";
function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("productOrder");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFiterDrawer = () => setFilterShow(!isFilterShow);

  const [isOrderExportShow, setOrderExportShow] = useState(false);
  const handleOrderExportDrawer = () => setOrderExportShow(!isOrderExportShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);

  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: ``,
    to: `${moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')}`,
    filter_by: "order_no",
    search: "CKP",
  }); //End

  const [fromDate, setFromDate] = useState(`${moment().startOf('day').format('YYYY-MM-DD HH:mm:ss')}`);
  const [toDate, setToDate] = useState(`${moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')}`);

  const [showRequest, setShowRequest] = useState("");
  
  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...((filter?.filter_by === "order_no"  && filter?.search !== 'CKP')
            ? { order_no: { $regex: filter?.search, $options: "i" } }
            : null),
          ...(filter?.filter_by === "name"
            ? { name: { $regex: filter?.search, $options: "i" } }
            : null),
            ...(filter?.filter_by === "buyer_first_name"
              ? { buyer_first_name: { $regex: filter?.search, $options: "i" } }
              : null),
              ...(filter?.filter_by === "buyer_last_name"
                ? { buyer_last_name: { $regex: filter?.search, $options: "i" } }
                : null),
                ...(filter?.filter_by === "buyer_mobile"
                  ? { buyer_mobile: parseInt(filter?.search) }
                  : null),
                ...(filter?.filter_by === "seller_first_name"
                  ? { seller_first_name: { $regex: filter?.search, $options: "i" } }
                  : null),
                  ...(filter?.filter_by === "seller_last_name"
                    ? { seller_last_name: { $regex: filter?.search, $options: "i" } }
                    : null),
          ...(filter?.filter_by === "seller_mobile"
            ? { seller_mobile: parseInt(filter?.search) }
            : null),
              ...(filter?.filter_by === "unit"
                ? { unit: parseInt(filter?.search) }
                : null),
                ...(filter?.filter_by === "seller_pos_number"
                  ? { seller_pos_number: parseInt(filter?.search) }
                  : null),
                  ...(filter?.filter_by === "rate"
                    ? { rate: parseInt(filter?.search) }
                    : null),
                    ...(filter?.filter_by === "qty"
                      ? { qty: parseInt(filter?.search) }
                      : null),
          ...(filter?.from?{createdAt : {$gte : filter.from, $lte : filter.to} }:null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {},
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await Orderlist(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT));
        } else {
          setListData([]);
          setTotalPages(getPage(1));
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter("");
      setFromDate("");
      setToDate("");
      inputRef1.current.value = "";
      inputRef2.current.value = "";
      inputRef3.current.value = "";
      inputRef4.current.value = "";

    } catch (error) {}
  };

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      const to = moment(form.get('to_date')).format('YYYY-MM-DD HH:mm:ss')
      const from = moment(form.get('from_date')).format('YYYY-MM-DD HH:mm:ss')
      setFilter((pre) => ({
        ...pre,
        filter_by: form.get("filter_by") || "",
        search: form.get("search") || "",
        'to'        : form.get('to_date') ? moment(to).format('YYYY-MM-DD HH:mm:ss') : '',
        'from'      : form.get('from_date') ? moment(from).format('YYYY-MM-DD HH:mm:ss') : ''
      }));
      // getList();
      handleFiterDrawer();
      setSkip(0);
    } catch (error) {}
  };
  const getGeneralData = async () => {
    try {
      const res = await generalData();
      if(res?.status === true){
        const { draw_start_time, draw_end_time } = res.result;
        if(draw_start_time) setFromDate(`${moment().format('YYYY-MM-DD')} ${draw_start_time}`)
        if(draw_end_time) setToDate(`${moment().format('YYYY-MM-DD')} ${draw_end_time}`)
      }  
    } catch (error) {
      
    }
  }
  useEffect(()=>{
    getGeneralData();
  },[])

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
    document.title = "Crown King || Product order's list";
  }, [currentPage, showRequest, LIMIT, filter]);

  const [confirmPopup, setConfirmPopup] = useState(false);
  const toggleConfirmPopup = () => setConfirmPopup(!confirmPopup);

  const [cancelOrderId, setCancelOrderId] = useState('');

  
  const [deliveryConfirmPopup, setDeliveryConfirmPopup] = useState(false);
  const toggleDeliveryConfirmPopup = () => setDeliveryConfirmPopup(!deliveryConfirmPopup);

  const [deliveryOrderId, setDeliveryCancelOrderId] = useState('');
  const cancelProductOrder = async ()=>{
    try {
      if(!cancelOrderId){
        notification.open({
          message: "Oops!",
          description: `Id not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }else{
        setIsLoading(true);
        const option = { orderId : cancelOrderId }
        const res = await cancelOrder(option);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Order Cancel successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else{
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const changeOrderDeliveryStatus = async ()=>{
    try {
      if(!deliveryOrderId){
        notification.open({
          message: "Oops!",
          description: `Order no. not found.`,
          placement: "topRight",
          icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
          duration: 2,
        });
      }else{
        setIsLoading(true);
        const option = { orderId : deliveryOrderId }
        const res = await changeDeliveryStatus(option);
        console.log('res : ', res);
        if(res.status === true){
          getList();
          notification.open({
            message: "Success",
            description: `Order Cancel successfully.`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faCheckCircle} style={{ color: "green" }} />,
            duration: 2,
          });
        } else{
          notification.open({
            message: "Oops!",
            description: `${res.message}`,
            placement: "topRight",
            icon: <FontAwesomeIcon icon={faExclamationCircle} style={{ color: "red" }} />,
            duration: 2,
          });
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const handleFilterChange = (e) =>{
    const {name, value} = e.target;
    if(name === 'filter_by' && value === 'order_no'){
      setFilter((pre)=>({
        ...pre,
        [name] : value,
        search : 'CKP'
      }))
    } else if(name === 'filter_by' && value !== 'order_no'){
      setFilter((pre)=>({
        ...pre,
        [name] : value,
        search : ''
      }))
    } else if(name === 'from_date'){
      setFromDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else if(name === 'to_date'){
      setToDate(`${moment(value).format('YYYY-MM-DD HH:mm:ss')}`)
    } else {
      setFilter((pre)=>({
        ...pre,
        [name] : value
      }))
    }
  }
  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"Order's list"}></TobNavBar>
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div>
                    <ShowData setLimit={setLimit} limit={LIMIT}/>
                  </div>
                  <div className="inventory_filter_div" onClick={handleFiterDrawer} >
                    <FontAwesomeIcon icon={faFilter} />
                    <Link to={false} className="filter_btn_invontry_rating_review" > Filter </Link>
                  </div>
                  {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.export === 'Y') && (
                    <div className="inventory_filter_div px-4" onClick={handleOrderExportDrawer} >
                      <FontAwesomeIcon icon={faCloudDownload} />
                      <Link to={false} className="filter_btn_invontry_rating_review" > Export </Link>
                    </div>
                  )}

                  <div className="inventory_filter_div"> 
                    <Link to={false} onClick={()=>getList()}><FontAwesomeIcon icon={faRefresh}/></Link>
                  </div>

                </div>
              </div>
            </Box>
            <VendorList>
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div className="card shadow mb-4">
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table className="table table-bordered" id="dataTable" width="100%" cellspacing="0" >
                          <thead>
                            <tr>
                              <th>Sl. No.</th>
                              <th>Product</th>
                              <th>Order No.</th>
                              <th>Seller's Details</th>
                              <th>Buyer's Details</th>
                              <th>Unit</th>
                              <th>Qty</th>
                              <th>Rate</th>
                              <th>Total</th>
                              <th>Voucher Number</th>
                              <th>Delivery type</th>
                              <th>Delivery Status</th>
                              <th>Status</th>
                              <th>Date</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div className="admin_prodcut_list_spanotherimg">
                                      <img
                                        src={ `${ASSETS_BASE_URL}${item.product_id?.image}` }
                                        alt="Product Image"
                                        width={`70px`}
                                      />
                                      <span className="admin_prodcut_list_span_name">
                                        {item.product_id?.name}
                                      </span>
                                    </div>
                                  </td>
                                  
                                  <td>{item?.order_no}</td>
                                  <td>
                                    Name : {`${item?.seller_first_name} ${item?.seller_last_name}` } <br/>
                                    Mobile : {`${item?.seller_mobile}`} <br/>
                                    POS No. : {`${item?.seller_pos_number}`} <br/>
                                  </td>
                                  <td>
                                    Name : {`${item?.buyer_first_name} ${item?.buyer_last_name}` } <br/>
                                    Mobile : {`${item?.buyer_mobile}`} <br/>
                                  </td>
                                  <td>{item?.variant_id?.unit}</td>
                                  <td>{item?.qty}</td>
                                  <td>{item?.points}</td>
                                  <td>{item?.points * item?.qty}</td>
                                  <td>{item.voucher_number || "N/A"}</td>
                                  <td>{item?.isDelivery === 'Y'?`Delivery`:`Pickup`}</td>
                                  <td>{item?.deliveryStatus}</td>
                                  <td dangerouslySetInnerHTML={{__html: statusMessage(item?.status)}}></td>
                                  <td >{moment(formatProjectDate(item?.createdAt)).format('DD-MM-YYYY h:mm A')}</td>
                                  <td>
                                    {(PERMISSION?.fullAccess === 'Y' || PERMISSION?.view === 'Y') && (
                                      <Dropdown
                                        placement="bottomLeft"
                                        arrow
                                        overlay={
                                          <Menu>
                                            <Menu.Item key={`1`} onClick={() => { navigate("/product/order/details", { state: { item } } ) }} >
                                              <FontAwesomeIcon icon={faEye} />{" "}
                                              <span className="show_span"> View </span>
                                            </Menu.Item>
                                            {(item?.deliveryStatus === 'Pending' && item?.status === 'Success') && (
                                              <Menu.Item key={`2`} onClick={() => { 
                                                setDeliveryCancelOrderId(item._id);
                                                toggleDeliveryConfirmPopup()
                                                }} >
                                                <FontAwesomeIcon icon={faTruck} />{" "}
                                                <span className="show_span">Shipped</span>
                                              </Menu.Item>
                                            )}
                                            {(item?.deliveryStatus === 'Shipped' && item?.status === 'Success') && (
                                              <Menu.Item key={`2`} onClick={() => { 
                                                setDeliveryCancelOrderId(item._id);
                                                toggleDeliveryConfirmPopup()
                                                }} >
                                                <FontAwesomeIcon icon={faCheckCircle} />{" "}
                                                <span className="show_span">Delivered</span>
                                              </Menu.Item>
                                            )}
                                            {item?.status === 'Success' && (
                                              <Menu.Item key={`2`} onClick={() => { 
                                                setCancelOrderId(item._id);
                                                toggleConfirmPopup()
                                                }} >
                                                <FontAwesomeIcon icon={faTimes} />{" "}
                                                <span className="show_span">Cancel</span>
                                              </Menu.Item>
                                            )}
                                          </Menu>
                                        }
                                      >
                                        <FontAwesomeIcon icon={faEllipsis} />
                                      </Dropdown>
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : isLoading ? (
                              <SkeltonList row={5} col={13} />
                            ) : (
                              <tr>
                                <td colSpan="13" className="img-center">
                                  No data found!
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      {/* Export*/}

      <ExportPopup
        popUpOpen={isOrderExportShow}
        togglePopUp={handleOrderExportDrawer}
      />
      <ConfirmPopup popUpOpen={confirmPopup} togglePopUp={toggleConfirmPopup} process={cancelProductOrder} />

      <ConfirmPopup popUpOpen={deliveryConfirmPopup} togglePopUp={toggleDeliveryConfirmPopup} process={changeOrderDeliveryStatus} />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFiterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFiterDrawer}>Cancel</Button>
            <Button
              type="primary"
              onClick={handleFilterReset}
              style={{ backgroundColor: "var(--brand-red)", color: "white" }}
            >
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id="filter_form" onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  Search Field :
                </label>
                <select
                  name="filter_by"
                  className="form-control store_input_field"
                  id="filter_by"
                  ref={inputRef1}
                  onChange={handleFilterChange}
                >
                  <option value="">Select search field</option>
                  <option
                    value="order_no"
                    selected={filter?.filter_by === "order_no" ? true : false}
                  >
                    Order no.
                  </option>
                  <option
                    value="product_name"
                    selected={filter?.filter_by === "product_name" ? true : false}
                  >
                    Product name
                  </option>
                  <option
                    value="voucher_number"
                    selected={
                      filter?.filter_by === "voucher_number" ? true : false
                    }
                  >
                    Voucher no.
                  </option>
                  <option
                    value="buyer_first_name"
                    selected={
                      filter?.filter_by === "buyer_first_name" ? true : false
                    }
                  >
                    Buyer's first name

                  </option>
                  <option
                    value="buyer_last_name"
                    selected={
                      filter?.filter_by === "buyer_last_name" ? true : false
                    }
                  >
                  Buyer's last name
                  </option>
                  <option
                    value="buyer_mobile"
                    selected={
                      filter?.filter_by === "buyer_mobile" ? true : false
                    }
                  >
               Buyer's mobile
                  </option>
                  <option
                    value="seller_first_name"
                    selected={
                      filter?.filter_by === "seller_first_name" ? true : false
                    }
                  >
                  Seller's first name
                  </option>
                  <option
                    value="seller_last_name"
                    selected={
                      filter?.filter_by === "seller_last_name" ? true : false
                    }
                  >
                    Seller's last name
                  </option>
                  <option
                    value="seller_mobile"
                    selected={
                      filter?.filter_by === "seller_mobile" ? true : false
                    }
                  >
                    Seller's mobile
                  </option>
                  <option
                    value="seller_pos_number"
                    selected={
                      filter?.filter_by === "seller_pos_number" ? true : false
                    }
                  >
                  Seller's POS number
                  </option>
                  <option
                    value="qty"
                    selected={
                      filter?.filter_by === "qty" ? true : false
                    }
                  >
                    Qty
                    </option>
                  <option
                    value="unit"
                    selected={
                      filter?.filter_by === "unit" ? true : false
                    }
                  >
                 Unit
                  </option>
                  <option
                    value="rate"
                    selected={
                      filter?.filter_by === "rate" ? true : false
                    }
                  >
                    Rate
                    </option>
                  <option
                    value="status"
                    selected={
                      filter?.filter_by === "status" ? true : false
                    }
                  >
                    
                   Status 
                  </option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  value={filter?.search}
                  className="form-control store_input_field"
                  id="search"
                  ref={inputRef2}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  From : 
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="from_date"
                  value={fromDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="from_date"
                  ref={inputRef3}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label
                  htmlFor="vendor_first_name"
                  className="all_section_for_label_main_class"
                >
                  To :
                </label>
                <input
                  title="Enter search text."
                  type="datetime-local"
                  name="to_date"
                  value={toDate}
                  onChange={handleFilterChange}
                  className="form-control store_input_field"
                  id="to_date"
                  ref={inputRef4}
                />
              </div>
              <br />
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"
                  style={{ backgroundColor: "var(--brand-red-dark)", color: "white" }}
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
